var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "29 690 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 703H36C34.1362 703 33.2044 703 32.4693 703.304C31.4892 703.71 30.7105 704.489 30.3045 705.469C30 706.204 30 707.136 30 709M43.5 691.291C44.9659 691.884 46 693.321 46 695M39.9999 709.5L42.025 709.095C42.2015 709.06 42.2898 709.042 42.3721 709.01C42.4452 708.981 42.5147 708.944 42.579 708.899C42.6516 708.848 42.7152 708.785 42.8426 708.657L49.5 702C50.0524 701.448 50.0523 700.552 49.5 700C48.9477 699.448 48.0523 699.448 47.5 700L40.8425 706.657C40.7152 706.785 40.6516 706.848 40.601 706.921C40.5561 706.985 40.5189 707.055 40.4902 707.128C40.458 707.21 40.4403 707.298 40.405 707.475L39.9999 709.5ZM41.5 695C41.5 697.209 39.7091 699 37.5 699C35.2909 699 33.5 697.209 33.5 695C33.5 692.791 35.2909 691 37.5 691C39.7091 691 41.5 692.791 41.5 695Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManagement);
export default __webpack_public_path__ + "static/media/user-management.80296cf34345756b550656a665d17247.svg";
export { ForwardRef as ReactComponent };